import React, { createContext, useContext, useState, useEffect } from 'react';
import apiClient from '../api/apiClient';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [error, setError] = useState(null);

  // Tjek om vi allerede er logget ind når siden loader (refresh)
  useEffect(() => {
    const token = localStorage.getItem('authToken');
    const savedUser = localStorage.getItem('userData');
    if (token && savedUser) {
      setUser(JSON.parse(savedUser));
    }
  }, []);

  const login = async (email, password, accessId = null) => { // Tag imod accessId
    try {
      setError(null);
      // Vi sender accessId med hvis det findes
      const response = await apiClient.post('/api/auth/login', { email, password, accessId });

      // CASEN HVOR VI SKAL VÆLGE SKOLE
      if (response.data.requireContextSelection) {
        // Returner listen, men sæt ikke user state endnu
        return { 
          requiresSelection: true, 
          contexts: response.data.contexts 
        };
      }

      // CASEN HVOR VI ER LOGGET IND
      if (response.data.token) {
        localStorage.setItem('authToken', response.data.token);
        localStorage.setItem('userData', JSON.stringify(response.data.user));
        setUser(response.data.user);
        return { success: true };
      }

    } catch (err) {
      console.error("Login error", err);
      setError(err.response?.data?.message || 'Fejl ved login');
      return { success: false };
    }
  };

  const logout = () => {
    // SLET ALT
    localStorage.removeItem('authToken');
    localStorage.removeItem('userData');
    setUser(null);
  };

  const updateUser = (userData) => {
    setUser(prev => {
        const newUser = { ...prev, ...userData };
        localStorage.setItem('userData', JSON.stringify(newUser)); // Opdater også local storage
        return newUser;
    });
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, updateUser, error }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);